import { Component } from '@angular/core';

import { AuthFacadeService } from '@ib-core/services/auth-facade.service';
import { DATA_TYPE } from '@ib-shared/types/data.type';
import { map } from 'rxjs';

import { DashboardFacadeService } from '../../services/dashboard-facade.service';

@Component({
  selector: 'ib-dashboard-balances',
  templateUrl: './dashboard-balances.component.html',
  styleUrls: ['./dashboard-balances.component.scss'],
})
export class DashboardBalancesComponent {
  public DATA_TYPE = DATA_TYPE;
  public balancesResponse$ = this.facadeS
    .selectBalances()
    .pipe(map(r => ({ v: r })));
  get currency(): string {
    return this.authFacadeS.authUser?.bankCurrency?.toLowerCase();
  }
  constructor(
    private facadeS: DashboardFacadeService,
    public authFacadeS: AuthFacadeService,
  ) {}

  openModal(): void {
    this.facadeS.toggleTransferModal(true);
  }
}
